/* istanbul ignore file */
import { array as codecArray, number as codecNumber, optional as codecOptional, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { RemovedPermissions } from './RemovedPermissions';
import { SessionRestrictionContext } from './SessionRestrictionContext';
const SessionRestrictionDataParser = 
/* #__PURE__ */ parsers.object([
    [
        'forContext',
        /* #__PURE__ */ codecOptional(SessionRestrictionContext),
        'for_context',
    ],
    [
        'removedPermissions',
        /* #__PURE__ */ codecOptional(RemovedPermissions),
        'removed_permissions',
    ],
    [
        'verifiedAssignmentIds',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.setFromArray(codecArray(codecNumber))),
        'verified_assignment_ids',
    ],
    [
        'verifiedCourseIds',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.setFromArray(codecArray(codecNumber))),
        'verified_course_ids',
    ],
]);
export class SessionRestrictionData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return SessionRestrictionDataParser.decode(input).map(res => new SessionRestrictionData(res));
    }
    static unsafeDecode(input) {
        return SessionRestrictionData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return SessionRestrictionDataParser.encode(data);
    }
    static schema() {
        return SessionRestrictionDataParser.schema();
    }
}
